import {disableLoader, enableLoader} from "@/helpers/loader";
import { EventBus } from '~/plugins/event-bus';

export default {
    async fetch ({commit}, payload) {
        try {
            const result = await this.$axios.get('api/me/workers/' + payload.slug);
            commit('setWorker', result.data.data);
        } catch (error) {
            commit('setError', error);
        }
    },
    async updateProfile({commit}, payload) {
        enableLoader()
        try {
            const result = await this.$axios({
                method: 'put',
                url: '/api/me/workers/' + payload.data.id + '/profile-update',
                data: payload.data,
                }).then( res =>{
                this.$router.back();
            }).catch((err)=>{
                EventBus.$emit('createSnackbar', {
                    message: 'Error updating worker, check all tabs for errors!',
                });
                commit('setError', err);
            });
        } catch (error) {
            EventBus.$emit('createSnackbar', {
                message: 'Error updating worker, check all tabs for errors!',
            });
            commit('setError', error);
        }
        disableLoader()
    }
}